import React, { memo } from 'react';
import { fg } from '@atlassian/jira-feature-gating';
import { useIntl } from '@atlassian/jira-intl';
import type { IssueId } from '@atlassian/jira-shared-types/src/general.tsx';
import type { OnItemDrop } from '@atlassian/timeline-table/common/types/callbacks';
import type { ListItemMenuOptionProps } from '@atlassian/timeline-table/renderers';
import { useIssueParentMap } from '../../../../common/utils/use-issue-parent-map.tsx';
import { useIssuesMap } from '../../../../common/utils/use-issues-map.tsx';
import messages from './messages.tsx';
import ReparentMenu from './reparent-menu/index.tsx';

type Props = {
	id: IssueId;
	Option: ListItemMenuOptionProps['Option'];
	setCloseMenu: ListItemMenuOptionProps['setCloseMenu'];
	updateIssueParent: OnItemDrop;
};

const ReparentMenuOption = ({ id, Option: MenuOption, setCloseMenu, updateIssueParent }: Props) => {
	const [{ issueParentMap }] = useIssueParentMap();
	const parentId = issueParentMap.get(id);
	const [{ issuesMap }] = useIssuesMap();
	const { formatMessage } = useIntl();
	const issue = issuesMap.get(id);
	if (!issue || !parentId) {
		return null;
	}
	return (
		<MenuOption
			label={formatMessage(
				fg('jira-issue-terminology-refresh-m3')
					? messages.changeParentIssueIssueTermRefresh
					: messages.changeParentIssue,
			)}
		>
			{({ setInitialFocusRef }) => (
				<ReparentMenu
					id={id}
					level={issue.issueType.hierarchyLevel}
					parentId={parentId}
					setInitialFocusRef={setInitialFocusRef}
					setCloseMenu={setCloseMenu}
					updateIssueParent={updateIssueParent}
				/>
			)}
		</MenuOption>
	);
};

export default memo(ReparentMenuOption);
